module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/feature_one-a51ca6c9fe86831f16c3bc60dcc94bc6.png";